import { graphql } from '@/generated/gql';

export const DEMAND_PROCESS_STEPS_QUERY = graphql(/* GraphQL */ `
  query DemandProcessSteps($id: UUID!) {
    tesseract {
      demand(id: $id) {
        id
        processSteps {
          variant
          status
        }
      }
    }
  }
`);
